export enum UserTier {
  FREE = "free",
  PREMIUM = "premium",
}

export const TIER_NAMES: Record<UserTier, string> = {
  [UserTier.FREE]: "Free",
  [UserTier.PREMIUM]: "Premium",
};

export const CIRCLE_LIMITS: Record<UserTier, number> = {
  [UserTier.FREE]: 3,
  [UserTier.PREMIUM]: -1, // unlimited
};
